module.exports = __webpack_public_path__ + "img/woodpecker_squeezed.90168af0.png";